module.exports = __webpack_public_path__ + "static/Gilroy-Bold-17cb9303df7b7264b9c4ef0953366617.otf";